import type { WindowDescriptor } from '@krp/client-runtime'
import type { ReceiptsUiState } from '../../reducer'
import { cashierAnalyticsPatched, decodeCashierAnalyticsIntent } from '../cashier-analytics/model/analyticsSlice'

export const CASHIER_GROUPS_WINDOWS = { report: 'receipts.cashierGroups.report' } as const
const capture = (state: ReceiptsUiState) => ({ intent: state.cashierAnalytics })
const restore = (snapshot: Record<string, unknown>) => { const value = decodeCashierAnalyticsIntent(snapshot.intent); return value === undefined ? [] : [cashierAnalyticsPatched(value)] }
export const cashierGroupsWindows: readonly WindowDescriptor<ReceiptsUiState>[] = [
  { kind: CASHIER_GROUPS_WINDOWS.report, scope: 'global', paths: ['/receipts-service/groups'], label: 'Объединение кассиров', presentation: 'page', section: { id: 'receipts' }, capture, restore },
]
